import { render, staticRenderFns } from "./ChartContactIcons.vue?vue&type=template&id=6efdbfb9&scoped=true"
import script from "./ChartContactIcons.vue?vue&type=script&lang=ts"
export * from "./ChartContactIcons.vue?vue&type=script&lang=ts"
import style0 from "./ChartContactIcons.vue?vue&type=style&index=0&id=6efdbfb9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efdbfb9",
  null
  
)

export default component.exports